// Vite entry point: styles plus the JSInterop utility modules, which self-register on window.
// Inactivity tracking lives in CDPHE.HealthInformatics.UI (window.SessionManager).
import './styles/main.scss';

import './utils/storage';
import './utils/dom';
import './utils/browser';
import './utils/animation';

console.log('✅ NaturalMedicine.App - Vite loaded successfully');
console.log('📦 Available JSInterop utilities:', {
  storage: 'storageUtils',
  dom: 'domUtils',
  browser: 'browserUtils',
  animation: 'animationUtils'
});

// Vite build mode, separate from Blazor's IWebAssemblyHostEnvironment.Environment.
console.log('🌍 Vite build mode:', import.meta.env.MODE);
